<div
  [ngStyle]="{
    '--height': height + 'px',
  }"
  class="chart"
>
  <canvas
    #radarchartcanvas
    [class.hidden]="!isDataAvailable() || isLoading"
    [id]="id"
    height="{{ height }}"
    width="{{ width }}"
    [ngStyle]="{ height: height }"
  ></canvas>
  @if (isLoading) {
    <div class="spinner-wrapper">
      <app-loading-spinner />
    </div>
  } @else if (!isDataAvailable()) {
    <div class="no-data">
      <ng-icon name="reports" size="64"></ng-icon>
      <p>{{ dictionaryService.get('NoDataFound') }}</p>
    </div>
  }
</div>
